// extracted by mini-css-extract-plugin
module.exports = {"container":"IFrame_container__2omF-","frame":"IFrame_frame__Uh0-X","poster":"IFrame_poster__YlvGy","title":"IFrame_title__1Kg0L","open":"IFrame_open__1HfBx"};